import { supabase } from "../../lib/supabaseClient";

export async function getAdminNews() {
    const { data, error } = await supabase
        .from("news")
        .select("*")
        .order("created_at", { ascending: false });

    if (error) {
        throw new Error(error.message);
    }

    return data;
}

export async function getNewsById(id) {
    const { data, error } = await supabase
        .from("news")
        .select("*")
        .eq("id", id)
        .single();

    if (error) {
        throw new Error(error.message);
    }

    return data;
}

export async function createNews(payload) {
    const { data, error } = await supabase
        .from("news")
        .insert(payload)
        .select()
        .single();

    if (error) {
        throw new Error(error.message);
    }

    return data;
}

export async function updateNews(id, payload) {
    const { data, error } = await supabase
        .from("news")
        .update({
            ...payload,
            updated_at: new Date().toISOString(),
        })
        .eq("id", id)
        .select()
        .single();

    if (error) {
        throw new Error(error.message);
    }

    return data;
}

export async function deleteNews(id) {
    const { error } = await supabase.from("news").delete().eq("id", id);

    if (error) {
        throw new Error(error.message);
    }
}